import React from 'react'
import './SucessmsgQB/SucessMsgQb.css'
import Loader from '../../Helper/Loader'

export default function DeleteConfirmationPopup({
    setOpenDeleteQuestionBankConfirmationPopup,
    deleteQuestionBankData,
    handleDeleteQuestionBank,
    isProcessLoading
}) {
    return (
        <div className='Conteiner_sucessMsg_QB' style={{ zIndex: 999 }}>
            <div className='subConteiner_sucessMsg_QB p-4'>
                {
                    isProcessLoading ? <Loader /> : <>
                        <div className='d-flex justify-content-center mt-3'>
                            <span className=" my-4 successfully_message">
                                Are you sure to delete question bank ?
                            </span>
                        </div>
                        <div className='d-flex justify-content-center mt-3'>
                            <button className='sucess_okayBtn_Qb' onClick={() => { handleDeleteQuestionBank(deleteQuestionBankData.questionBankId) }}>Yes</button>
                            <button className='sucess_okayBtn_Qb ms-3' onClick={() => { setOpenDeleteQuestionBankConfirmationPopup(false) }}>No</button>
                        </div>
                    </>
                }
            </div>

        </div>
    )
}
